exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-104c607d] .el-dialog__body {\n  padding: 20px;\n}\n.wrapper[data-v-104c607d] {\n  height: 560px;\n  overflow-y: auto;\n}\n@media screen and (max-height: 820px) {\n.wrapper[data-v-104c607d] {\n    height: 460px;\n    overflow-y: auto;\n}\n}\n@media screen and (max-height: 700px) {\n.wrapper[data-v-104c607d] {\n    height: 340px;\n    overflow-y: auto;\n}\n}\n", ""]);

// exports
